@if ((archivedListDataSource.loading$ | async) === false) {
  <ngx-zero-state class="zero-state-data-source-empty">
    <h1 zero-state-title translate="archive-zero-state_title"></h1>
    <div zero-state-body translate="archive-zero-state_description"></div>
  </ngx-zero-state>
} @else {
  <section class="loading-state">
    <loading></loading>
  </section>
}

